<chat-list-tag>
	<div class="container_contents">

		<div class="container_breadcrumb">
			<ul class="breadcrumb">
				<li class="breadcrumb-item"><a href="/chat" class="chat">チャットルーム</a></li>
				<li class="breadcrumb-item"><h1>{state.client.name}</h1></li>
			</ul>
		</div><!--/.container_breadcrumb-->
		
		<div class="contents">
			
			<section class="contents_area">

				<div class="container_sort margin-spacing-2_bottom">
					<div class="box_sort">
						<div class="sort-menu margin-spacing-2_right">
							<select name="sort" class="sort-list" onchange={e=>changeActive(e)}>
								<option value="0">全て</option>
								<option value="1">稼働中</option>
							</select>
						</div><!--/.sort-menu-->
					</div><!--/.box_sort-->
          <p class="search_number" if="{ state.pager.total > 0}">
            全{ state.pager.total }件中 { state.limit*(state.pager.page-1)
            + 1 }〜{ state.limit*(state.pager.page-1) +
            state.pager.items.length }件
          </p>
				</div><!--/.container_sort-->
				
				<div class="contents_block margin-spacing-2_bottom {chatUnread(room.unread_num)}" room={room} idx={i} each={(room,i) in state.rooms} style="{isFreezed(room.freezed_at)}" >
          <project-item room={room} if={room.project_id>0}></project-item>
          <ad-item room={room} if={room.project_id === 0 && room.ad_id}></ad-item>
				</div><!--/.contents_block-->

				<edilent-pagination-tag pager="{state.pager}" onpager="{(e,page)=>select(e,page)}" if={state.pager.last > 0}></edilent-pagination-tag>        
				
			</section><!--/.contents_area-->
			
		</div><!--/.contents-->
		
	</div><!--/.container_contents-->
<script>
  import di from "dependency-injection";
  import projectItem from "@tags/pages/chat/project-item.riot";
  import adItem from "@tags/pages/chat/ad-item.riot";

  export default {
    components: {
      'project-item': projectItem,
      'ad-item': adItem,
    },
    client_id: null,
    state: {
      limit: 10,
      active: false,
      client: {},
      rooms: [],
      page: 1,
      pager: {page: 1, total: 0, last: 0,  prev: 0, next: 0}
    },
    isFreezed(freezed_at) {
      if (freezed_at) return 'background-color: #ddd; ';
      return '';
    },
    chatUnread(unread) {
      if (unread > 0) {
        return 'chat_unread';
      }
      return '';
    },
    changeActive(e) {
      this.state.page = 1;
      this.state.active = (e.target.value == "1")? true:false;
      this.fetchRooms();
    },
    select(e, page) {
      e.preventDefault();
      this.state.page = page;
      this.fetchRooms();
    },
    onRoomsUpdate(data){
      this.update({
        client: data.client || {},
        rooms: data.paging.items,
        pager: data.paging,
        page : data.paging.page
      });
    },
    fetchRooms(){
      const params = {
        client_id: this.client_id,
        active: this.state.active,
        page: this.state.page
      };
      this.api.request('index', 'rooms', params)
        .then(data=>this.onRoomsUpdate(data));
    },
    onBeforeMount(props, state){
      if (!props.routeParams[0]) {
        return;
      }
      this.client_id = props.routeParams[0];
      this.api = di.createApi('chat');
      this.fetchRooms();
    }
  }
</script>
</chat-list-tag>
